// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-header[data-v-0485de20]{letter-spacing:6px;margin-bottom:25px;margin-top:25px;text-align:center}.active-menu[data-v-0485de20]{color:#111b27;position:relative}.active-menu[data-v-0485de20]:after{background-color:#111b27;bottom:-3px;content:\"\";height:1px;left:0;position:absolute;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
